import React, { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { getPrescriptionInfo } from '../../hooks/useGetPrescriptionInfo';
import { usePostRequest } from '../../hooks/usePostRequest';
import { useValidation } from '../../hooks/validationHooks/useValiation';
import { loginSuccess } from '../../store/slices/authSlice';
import {
  activeDoctorForAssistant,
  doctorListForAssistant,
} from '../../store/slices/doctorsOfAssistantSlice';
import {
  activeOrganization as activateOrg,
  organizationList,
} from '../../store/slices/orgSlice';
import {
  patientSettings,
  prescriptionFooter,
  prescriptionHeader,
  prescriptionItems,
  prescriptionSettings,
} from '../../store/slices/prescriptionSlice';
import { specialtyList } from '../../store/slices/specialtySlice';
import { getRequest } from '../../utils/axiosRequests';
import { signinSchema } from '../../validationSchemas/signin.validation';
import LoadingButton from './LoadingButton';

const SigninForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [authError, setAuthError] = useState('');
  const dispatch = useDispatch();

  const validation = useValidation;
  let navigate = useNavigate();

  const onSuccess = (data) => {
    console.log(data, 'user info');
    sessionStorage.setItem('token', JSON.stringify(data.token));
    dispatch(loginSuccess(data));

    if (data.userType === 'assistant') {
      getRequest(`assistants/${data.id}`)
        .then((data) => {
          dispatch(doctorListForAssistant(data?.doctorIds));
          dispatch(activeDoctorForAssistant(data?.doctorIds[0]));
          navigate('/appointments');
        })
        .catch((error) => {
          console.log(error);
        });
    }

    if (data.userType === 'doctor') {
      let selectedOrg = data.organizationIds[0];
      if (data?.doctorDetails?.selectedOrgId) {
        selectedOrg = data?.organizationIds?.find(
          (org) => org.id === data?.doctorDetails?.selectedOrgId,
        );
      }

      dispatch(activateOrg(selectedOrg || data?.organizationIds?.[0]));
      dispatch(organizationList(data.organizationIds));

      getPrescriptionInfo('specialty', '').then((data) => {
        dispatch(specialtyList(data));
      });
      getPrescriptionInfo('header', selectedOrg?.id).then((data) => {
        dispatch(prescriptionHeader(data));
      });
      getPrescriptionInfo('footer', selectedOrg?.id).then((data) => {
        dispatch(prescriptionFooter(data));
      });
      getPrescriptionInfo('prescriptionItem', selectedOrg?.id).then((data) => {
        dispatch(prescriptionItems(data));
      });
      getPrescriptionInfo('prescriptionPrint', selectedOrg?.id).then((data) => {
        dispatch(prescriptionSettings(data));
      });
      getPrescriptionInfo('patientItem', selectedOrg?.id).then((data) => {
        dispatch(patientSettings(data));
      });
      navigate('/prescription');
    }
  };

  const onError = (error) => {
    setAuthError(error.message);
    console.log('from react query error: ', error.message);
  };

  const { isLoading, mutate: submitUser } = usePostRequest(
    'auth/login',
    {
      username: username,
      password,
    },
    onSuccess,
    onError,
  );

  const handleSubmit = () => {
    const { isValid, errors } = validation(
      { username, password },
      signinSchema,
    );
    if (isValid) {
      submitUser();
    }
    {
      setErrors(errors);
    }
  };

  const getErrorMessage = (inputName) => {
    return errors[inputName] ? errors[inputName] : '';
  };

  return (
    <div>
      {authError && (
        <div className="v-error text-center mb-1">Sorry!!! {authError}</div>
      )}
      <Row className="mb-2">
        <Col>
          <label htmlFor="username">Mobile No or Email</label>
          <div className="form-group">
            <input
              type="text"
              autoComplete="off"
              className={`form-control ${
                getErrorMessage('username') ? 'v-border' : ''
              }`}
              id="username"
              placeholder="Enter mobile no or email"
              onChange={(e) => setUsername(e.target.value)}
            />
            <small className="v-error">{getErrorMessage('username')}</small>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <label htmlFor="password">Password </label>
          <div className="form-group" style={{ position: 'relative' }}>
            <input
              autoComplete="off"
              type={`${showPassword ? 'text' : 'password'}`}
              className={`form-control ${
                getErrorMessage('password') ? 'v-border' : ''
              }`}
              id="password"
              placeholder="Enter password"
              onChange={(e) => setPassword(e.target.value)}
            />
            {showPassword ? (
              <i
                className="fa fa-eye fa-fw pass-show-hide"
                aria-hidden="true"
                onClick={() => setShowPassword(false)}
              ></i>
            ) : (
              <i
                className="fa fa-eye-slash pass-show-hide"
                aria-hidden="true"
                onClick={() => setShowPassword(true)}
              ></i>
            )}
            <small className="v-error">{getErrorMessage('password')}</small>
          </div>
        </Col>
      </Row>
      <Row className="pb-1">
        <Col md="6">
          <div className="form-group">
            <input
              type="checkbox"
              name="remember"
              onChange={(e) => setRemember(e.target.value)}
            />{' '}
            Remember Me
          </div>
        </Col>
        <Col md="6" className="forgot-password">
          <div className="form-group">
            <Link className="signin-link" to="/forgot-password">
              {' '}
              Forgot Password
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="text-center signin-btn-area">
          <div className="d-grid gap-2">
            {isLoading ? (
              <LoadingButton btnFull="yes" />
            ) : (
              <Button
                type="submit"
                variant="primary"
                className="btn-color signin-btn"
                size="md"
                style={{ width: '100%' }}
                onClick={handleSubmit}
              >
                Sign In
              </Button>
            )}
          </div>
        </Col>
      </Row>
      <p className="pt-3 text-center signin-btn">
        Don't have an account?
        <Link className="signin-link" to="/signup">
          {' '}
          Sign Up
        </Link>
      </p>
    </div>
  );
};

export default SigninForm;
